<aside class="page-sidebar" *defineVariable="mobileService.mobileState$ | async as mobileState">
  <smart-logo></smart-logo>
  @if (mobileState.mobile) {
    <shop-name></shop-name>
  }
  <smart-navigation class="d-flex flex-column flex-fill shadow"></smart-navigation>
</aside>
